import * as React from 'react';
import './Heading.styles.scss';

export interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  children?: string;
  type?: 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

function toSlug(str?: string) {
  const value = String(str); // Coerce value to a string just in case

  if (!value) return undefined;
  // Convert the string to lowercase
  let slug = value.toLowerCase();

  // Replace any non-alphanumeric characters (excluding spaces) with an empty string
  slug = slug.replace(/[^\w\s]/g, '');

  // Replace spaces with dashes
  slug = slug.replace(/\s+/g, '-');

  return slug;
}

export const Heading = ({
  children,
  type = 'h2',
  id = type === 'h2' || type === 'h3' ? toSlug(children) : undefined,
  className,
}: HeadingProps) => {
  if (!children) return null;
  const [isCopied, setIsCopied] = React.useState(false);

  function copyToClipboard(value?: string) {
    if (!value) return;
    const path = window.location.href.split('#')[0];
    navigator.clipboard.writeText(`${path}#${value}`);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 3000);
  }

  return (
    <div className="mdx-heading">
      {React.createElement(
        type,
        { id, className },
        <>
          <span>{children}</span>
          {type === 'h2' || type === 'h3' ? (
            <button
              className="flex align-center"
              onClick={() => {
                copyToClipboard(id);
              }}>
              <span className="icon-heading">#</span>
              <span className={isCopied ? 'active' : undefined}>
                Copied URL
              </span>
            </button>
          ) : null}
        </>
      )}
    </div>
  );
};
